import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import React from 'react'
import { useSelector } from 'react-redux'

import { SchemaRecording } from '@/__generated/es-api'
import Loader from '@/app/component/atom/loader'
import { selectOrgId } from '@/app/module/user/store/selectors'

import CallRecordingsTableRow from './call-recordings-table-row'

type Props = {
  data: SchemaRecording[]
  downloadingId?: number
  loading: boolean
  onDownload: (id: number) => void
}

const CallRecordingsTable: React.FC<Props> = ({ data, downloadingId, loading, onDownload }) => {
  const orgId = useSelector(selectOrgId)
  const isEmpty = data.length === 0

  return (
    <TableContainer>
      <Table sx={isEmpty ? { borderBottom: 'none' } : undefined}>
        <TableHead>
          <TableRow sx={{ height: 44 }}>
            <TableHeadCell>Date</TableHeadCell>
            <TableHeadCell>Recording</TableHeadCell>
            <TableHeadCell>Transcript</TableHeadCell>
            <TableHeadCell>Campaign</TableHeadCell>
            <TableHeadCell>Contact</TableHeadCell>
            <TableHeadCell>User</TableHeadCell>
            <TableHeadCell align="center">Actions</TableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading && isEmpty && (
            <TableRow>
              <TableCell colSpan={7} align="center" sx={{ borderBottom: 'none' }}>
                <Typography variant="body2" color="text.secondary">
                  No recordings were found.
                </Typography>
              </TableCell>
            </TableRow>
          )}
          {data.map((r) => (
            <CallRecordingsTableRow
              key={r.id}
              recording={r}
              orgId={orgId}
              downloading={downloadingId === r.id}
              onDownload={onDownload}
            />
          ))}
        </TableBody>
      </Table>
      {(loading || !!downloadingId) && <Loader />}
    </TableContainer>
  )
}

const TableContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flex: 1,
  overflow: 'auto',

  '& table': {
    borderCollapse: 'separate',
    borderSpacing: 0,
    borderTop: 'none',
  },
})

const TableHeadCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  position: 'sticky',
  top: 0,
  zIndex: 1,
  borderTop: `1px solid ${theme.palette.divider}`,
  borderBottom: `1px solid ${theme.palette.divider}`,
  fontSize: '1rem',
}))

export default CallRecordingsTable
